'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

require('node-forge/lib/pkcs7');

require('node-forge/lib/pbe');

var forge = require('node-forge/lib/forge');

var _require = require('./util'),
    certificateForKey = _require.certificateForKey,
    findAsync = _require.findAsync;

var errcode = require('err-code');
/**
 * Cryptographic Message Syntax (aka PKCS #7)
 *
 * CMS describes an encapsulation syntax for data protection. It
 * is used to digitally sign, digest, authenticate, or encrypt
 * arbitrary message content.
 *
 * See RFC 5652 for all the details.
 */


var CMS = /*#__PURE__*/function () {
  /**
   * Creates a new instance with a keychain
   *
   * @param {Keychain} keychain - the available keys
   */
  function CMS(keychain) {
    _classCallCheck(this, CMS);

    if (!keychain) {
      throw errcode(new Error('keychain is required'), 'ERR_KEYCHAIN_REQUIRED');
    }

    this.keychain = keychain;
  }
  /**
   * Creates some protected data.
   *
   * The output Buffer contains the PKCS #7 message in DER.
   *
   * @param {string} name - The local key name.
   * @param {Buffer} plain - The data to encrypt.
   * @returns {undefined}
   */


  _createClass(CMS, [{
    key: "encrypt",
    value: function () {
      var _encrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(name, plain) {
        var key, pem, privateKey, certificate, p7, der;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (Buffer.isBuffer(plain)) {
                  _context.next = 2;
                  break;
                }

                throw errcode(new Error('Plain data must be a Buffer'), 'ERR_INVALID_PARAMS');

              case 2:
                _context.next = 4;
                return this.keychain.findKeyByName(name);

              case 4:
                key = _context.sent;
                _context.next = 7;
                return this.keychain._getPrivateKey(name);

              case 7:
                pem = _context.sent;
                privateKey = forge.pki.decryptRsaPrivateKey(pem, this.keychain._());
                _context.next = 11;
                return certificateForKey(key, privateKey);

              case 11:
                certificate = _context.sent;
                // create a p7 enveloped message
                p7 = forge.pkcs7.createEnvelopedData();
                p7.addRecipient(certificate);
                p7.content = forge.util.createBuffer(plain);
                p7.encrypt(); // convert message to DER

                der = forge.asn1.toDer(p7.toAsn1()).getBytes();
                return _context.abrupt("return", Buffer.from(der, 'binary'));

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function encrypt(_x, _x2) {
        return _encrypt.apply(this, arguments);
      }

      return encrypt;
    }()
    /**
     * Reads some protected data.
     *
     * The keychain must contain one of the keys used to encrypt the data.  If none of the keys
     * exists, an Error is returned with the property 'missingKeys'.  It is array of key ids.
     *
     * @param {Buffer} cmsData - The CMS encrypted data to decrypt.
     * @returns {undefined}
     */

  }, {
    key: "decrypt",
    value: function () {
      var _decrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(cmsData) {
        var _this = this;

        var cms, buf, obj, recipients, r, missingKeys, key, pem, privateKey;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (Buffer.isBuffer(cmsData)) {
                  _context3.next = 2;
                  break;
                }

                throw errcode(new Error('CMS data is required'), 'ERR_INVALID_PARAMS');

              case 2:
                _context3.prev = 2;
                buf = forge.util.createBuffer(cmsData.toString('binary'));
                obj = forge.asn1.fromDer(buf);
                cms = forge.pkcs7.messageFromAsn1(obj);
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](2);
                throw errcode(new Error('Invalid CMS: ' + _context3.t0.message), 'ERR_INVALID_CMS');

              case 11:
                // Find a recipient whose key we hold. We only deal with recipient certs
                // issued by ipfs (O=ipfs).
                recipients = cms.recipients.filter(function (r) {
                  return r.issuer.find(function (a) {
                    return a.shortName === 'O' && a.value === 'ipfs';
                  });
                }).filter(function (r) {
                  return r.issuer.find(function (a) {
                    return a.shortName === 'CN';
                  });
                }).map(function (r) {
                  return {
                    recipient: r,
                    keyId: r.issuer.find(function (a) {
                      return a.shortName === 'CN';
                    }).value
                  };
                });
                _context3.next = 14;
                return findAsync(recipients, /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(recipient) {
                    var _key;

                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return _this.keychain.findKeyById(recipient.keyId);

                          case 3:
                            _key = _context2.sent;

                            if (!_key) {
                              _context2.next = 6;
                              break;
                            }

                            return _context2.abrupt("return", true);

                          case 6:
                            _context2.next = 11;
                            break;

                          case 8:
                            _context2.prev = 8;
                            _context2.t0 = _context2["catch"](0);
                            return _context2.abrupt("return", false);

                          case 11:
                            return _context2.abrupt("return", false);

                          case 12:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, null, [[0, 8]]);
                  }));

                  return function (_x4) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 14:
                r = _context3.sent;

                if (r) {
                  _context3.next = 18;
                  break;
                }

                missingKeys = recipients.map(function (r) {
                  return r.keyId;
                });
                throw errcode(new Error('Decryption needs one of the key(s): ' + missingKeys.join(', ')), 'ERR_MISSING_KEYS', {
                  missingKeys: missingKeys
                });

              case 18:
                _context3.next = 20;
                return this.keychain.findKeyById(r.keyId);

              case 20:
                key = _context3.sent;
                _context3.next = 23;
                return this.keychain._getPrivateKey(key.name);

              case 23:
                pem = _context3.sent;
                privateKey = forge.pki.decryptRsaPrivateKey(pem, this.keychain._());
                cms.decrypt(r.recipient, privateKey);
                return _context3.abrupt("return", Buffer.from(cms.content.getBytes(), 'binary'));

              case 27:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 8]]);
      }));

      function decrypt(_x3) {
        return _decrypt.apply(this, arguments);
      }

      return decrypt;
    }()
  }]);

  return CMS;
}();

module.exports = CMS;